module.exports = __webpack_public_path__ + "static/media/logo-urbanosantos.4196651f.png";